<button pButton type="button" [label]="'Force sync collection with ' + this.entity" icon="pi pi-refresh" class="p-button-success p-button-sm sync-button" (click)="performAction()"></button>
<div *ngIf="message" class="notification" [ngClass]="{'show': message, 'hide': !message, 'error-message': isError}">
    {{ message }}
  </div>